export interface SkillGroup {
  category: string;
  items: string[];
}

export const skills: SkillGroup[] = [
  {
    category: 'Languages & Frameworks',
    items: ['C#', 'SQL', 'T-SQL', 'PL/SQL', 'TypeScript', 'JavaScript', '.NET 10', 'ASP.NET Core', 'Entity Framework Core', 'REST APIs', 'gRPC'],
  },
  {
    category: 'Data',
    items: ['Oracle', 'Microsoft SQL Server', 'Azure SQL', 'PostgreSQL', 'PostGIS', 'Redis', 'Relational & Spatial Data Modeling', 'Performance Tuning'],
  },
  {
    category: 'Cloud, DevOps & Workflow',
    items: ['Azure', 'Docker', 'Containerization', 'On-Premise Datacenter', 'Azure DevOps', 'CI/CD & Quality Gates', 'Git', 'Camunda 8 (BPMN)', 'Keycloak'],
  },
  {
    category: 'Geospatial',
    items: ['Esri ArcGIS', 'PostGIS', 'Mapbox', 'Vector Tiles', 'GeoJson', 'Spatial Query Optimization'],
  },
  {
    category: 'Architecture & Practices',
    items: ['Solution Architecture', 'Legacy Modernization', 'Modular Monolith', 'Microservices', 'Vertical Slice Architecture', 'Clean Architecture', 'Domain-Driven Design', 'Workflow Orchestration', 'TDD', 'Agile', 'Scrum'],
  },
  {
    category: 'AI-Assisted Engineering',
    items: ['Agentic Code Review', 'AI-Assisted Planning', 'Architecture Decision Records', 'Team Standards & Guardrails'],
  },
];
